import { URLS } from '@assets/environment/urls'
import axios from 'axios'
import { SubmitVideoResponse, VideoResults } from '@entities/video'

export class VideoHttpService {
	static baseUrl: string = URLS.WORKOUT + 'core/camera_api/'

	static getVideoStatus = async (sessionUuid: string): Promise<VideoResults | false> => {
		try {
			const response = await axios.get<VideoResults>(
				VideoHttpService.baseUrl + `check_status/${sessionUuid}`
			)
			return response.data
		} catch (e: unknown) {
			console.error(e)
			return false
		}
	}

	static submitVideo = async (exercise: string, video: File): Promise<boolean | string> => {
		try {
			const formData: FormData = new FormData()
			formData.append('exercise', exercise)
			formData.append('video', video)

			const response = await axios.post<SubmitVideoResponse>(
				VideoHttpService.baseUrl + 'submit_video',
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				}
			)

			return response.data.session_uuid
		} catch (e) {
			console.error('Error submitting video:', e)
			return false
		}
	}
}
